import { useContext } from 'react';
import { AuthContext } from './auth.context';
import { IUseAuth } from './use-auth.hook';

/**
 * Returns a context aware useAuth function
 * @returns
 */
export const useAuthContext = (): IUseAuth => useContext(AuthContext);
